import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { TEALIUM_PAGE_SUCCESS } from 'src/app/v1/analytics';
import { getTrackerSelector } from 'src/app/v1/dataAnalytics/utils/getTrackerSelector';
import { sendPageTracking } from 'src/app/v1/dataAnalytics/utils/sendPageTracking';
import type { AppState } from 'src/types/appState';

import { successPageSelector } from '../selectors/successPageSelector';

const selector = getTrackerSelector(successPageSelector);

export const SuccessPageTracker = () => {
  const { hasHirerInfo, page, isDataCleanUpComplete, isPageReady } =
    useSelector(selector);

  // TODO: remove this later
  const jobId = useSelector((state: AppState) => state.session.job?.id);

  useEffect(() => {
    if (
      page === TEALIUM_PAGE_SUCCESS &&
      hasHirerInfo &&
      isDataCleanUpComplete &&
      isPageReady
    ) {
      sendPageTracking(page);
    }
  }, [page, isPageReady, hasHirerInfo, isDataCleanUpComplete, jobId]);
  return <></>;
};
